import { createAction, props } from '@ngrx/store';
import { IResponseError } from '../../service/interface';
import {
	IDeleteRunResult,
	IJobResult,
	IPurgeResult,
	IRun,
	IRunResult,
	IScenario,
} from '../../service/test-fixtures/interface';
import { IRunsPagination } from './test-fixtures.interface';

// ── Scenarios ──

const loadScenarios = createAction('[TestFixtures/API] Load Scenarios');

const loadScenariosSuccess = createAction(
	'[TestFixtures/API] Load Scenarios Success',
	props<{ scenarios: IScenario[] }>(),
);

const loadScenariosError = createAction(
	'[TestFixtures/API] Load Scenarios Error',
	props<{ error: IResponseError }>(),
);

const setScenarioFilter = createAction(
	'[TestFixtures/UI] Set Scenario Filter',
	props<{ filter: { area?: string; tag?: string } }>(),
);

const runScenario = createAction(
	'[TestFixtures/API] Run Scenario',
	props<{ scenarioId: string; params?: Record<string, unknown> }>(),
);

const runScenarioSuccess = createAction(
	'[TestFixtures/API] Run Scenario Success',
	props<{ result: IRunResult }>(),
);

const runScenarioError = createAction(
	'[TestFixtures/API] Run Scenario Error',
	props<{ error: IResponseError }>(),
);

const clearRunResult = createAction('[TestFixtures/UI] Clear Run Result');

// ── Runs ──

const loadRuns = createAction('[TestFixtures/API] Load Runs');

const loadRunsSuccess = createAction(
	'[TestFixtures/API] Load Runs Success',
	props<{ runs: IRun[]; pagination: IRunsPagination }>(),
);

const loadRunsError = createAction(
	'[TestFixtures/API] Load Runs Error',
	props<{ error: IResponseError }>(),
);

const setRunsOffset = createAction(
	'[TestFixtures/UI] Set Runs Offset',
	props<{ offset: number }>(),
);

const setRunsLimit = createAction(
	'[TestFixtures/UI] Set Runs Limit',
	props<{ limit: number }>(),
);

const deleteRun = createAction(
	'[TestFixtures/API] Delete Run',
	props<{ runId: string }>(),
);

const deleteRunSuccess = createAction(
	'[TestFixtures/API] Delete Run Success',
	props<{ result: IDeleteRunResult }>(),
);

const deleteRunError = createAction(
	'[TestFixtures/API] Delete Run Error',
	props<{ error: IResponseError }>(),
);

const purgeRuns = createAction('[TestFixtures/API] Purge Runs');

const purgeRunsSuccess = createAction(
	'[TestFixtures/API] Purge Runs Success',
	props<{ result: IPurgeResult }>(),
);

const purgeRunsError = createAction(
	'[TestFixtures/API] Purge Runs Error',
	props<{ error: IResponseError }>(),
);

// ── Jobs ──

const runJob = createAction(
	'[TestFixtures/API] Run Job',
	props<{
		jobName: string;
		runId?: string;
		subject?: { actor?: string; decisionId?: string };
	}>(),
);

const runJobSuccess = createAction(
	'[TestFixtures/API] Run Job Success',
	props<{ result: IJobResult }>(),
);

const runJobError = createAction(
	'[TestFixtures/API] Run Job Error',
	props<{ error: IResponseError }>(),
);

const clearJobResult = createAction('[TestFixtures/UI] Clear Job Result');

// ── Shared ──

const clearError = createAction('[TestFixtures/UI] Clear Error');

export const TestFixturesActions = {
	loadScenarios,
	loadScenariosSuccess,
	loadScenariosError,
	setScenarioFilter,
	runScenario,
	runScenarioSuccess,
	runScenarioError,
	clearRunResult,
	loadRuns,
	loadRunsSuccess,
	loadRunsError,
	setRunsOffset,
	setRunsLimit,
	deleteRun,
	deleteRunSuccess,
	deleteRunError,
	purgeRuns,
	purgeRunsSuccess,
	purgeRunsError,
	runJob,
	runJobSuccess,
	runJobError,
	clearJobResult,
	clearError,
};
